import React from 'react';
import { Box } from 'styled-system/jsx';

const ParticipantIncidentActionsWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Box
      display="flex"
      flexDirection={'row'}
      gap={'10px'}
      justifyContent={'center'}
      paddingX={'45px'}
      paddingY={'12px'}
    >
      {children}
    </Box>
  );
};

export default ParticipantIncidentActionsWrapper;
